import {
  Checkbox,
  FormControlLabel,
  Tooltip,
  Typography,
} from '@material-ui/core'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import { useEffect } from 'react'

import Button from '@/components/button'
import { useCreatePulverizationMap } from '@/pages/diagnosis-view/contexts/create-pulverization-map-context'

import { ListItem } from './list-item'
import { useStyles } from './styles'

export function BufferLayers() {
  const classes = useStyles()

  const {
    infestationData,
    previousStep,
    applyBufferToLayer,
    toggleBufferToLayer,
    showBuffer,
    nextStep,
    intersect,
    setIntersect,
  } = useCreatePulverizationMap()

  useEffect(() => {
    showBuffer()
  }, [])
  return (
    <>
      <div className={classes.container}>
        <header>
          <Typography variant='h3'>
            Defina o tamanho do buffer de pulverização
          </Typography>
          <Typography>Buffer indicado: 10 m *</Typography>
        </header>

        <ul>
          {infestationData?.mergedLayersMap.map((layer, index) => (
            <ListItem
              key={layer.name}
              name={layer.name}
              bgColor={layer.colorPalette}
              border='1px solid #00000033'
              buffer={layer.buffer}
              buffered={layer.buffered}
              onSlideChange={(value) =>
                applyBufferToLayer('mergedLayersMap', index, value)
              }
              onCheckBufferChange={() =>
                toggleBufferToLayer('mergedLayersMap', index)
              }
            />
          ))}

          {infestationData?.layersMap.map(
            (layer, index) =>
              !layer.removed &&
              !layer.mergedName && (
                <ListItem
                  key={layer.name}
                  name={layer.name}
                  bgColor={layer.colorPalette}
                  border='none'
                  buffer={layer.buffer}
                  buffered={layer.buffered}
                  onSlideChange={(value) =>
                    applyBufferToLayer('layersMap', index, value)
                  }
                  onCheckBufferChange={() =>
                    toggleBufferToLayer('layersMap', index)
                  }
                />
              ),
          )}
        </ul>
      </div>

      <div>
        <div className={classes.checkboxContainer}>
          <FormControlLabel
            name='intersect'
            control={<Checkbox size='small' />}
            checked={intersect}
            onChange={(_, checked) => setIntersect(checked)}
            label='Aplicar intersecção com perímetro'
          />
          <Tooltip
            title='Ao aplicar a intersecção, todas as áreas de buffer 
            que ultrapassam o perímetro serão recortadas'
            placement='left'
            classes={{
              tooltip: classes.tooltip,
            }}
          >
            <InfoOutlinedIcon />
          </Tooltip>
        </div>
        <div className={classes.buttonContainer}>
          <Button outlined onClick={previousStep}>
            Voltar
          </Button>
          <Button
            onClick={nextStep}
            disabled={infestationData?.layersMap.every(
              (layer) => layer.removed,
            )}
          >
            Avançar
          </Button>
        </div>
      </div>
    </>
  )
}
